interface Props {
  nome: string;
  cor: string | null;
  total: number;
  homens: number;
  mulheres: number;
  idadeMedia: number | null;
  cidades: string;
  sugestoes?: number;
  ativo: boolean;
  aoSelecionar: () => void;
}

const CINZA = '#94A3B8';

// Cartão de uma tribo (ou "Sem tribo") na coluna da esquerda.
export default function CartaoTribo({
  nome,
  cor,
  total,
  homens,
  mulheres,
  idadeMedia,
  cidades,
  sugestoes = 0,
  ativo,
  aoSelecionar,
}: Props) {
  return (
    <button
      type="button"
      onClick={aoSelecionar}
      className={`relative w-full cursor-pointer overflow-hidden rounded-2xl border bg-white p-3 text-left transition-colors ${
        ativo
          ? 'border-foreground-950'
          : 'border-background-200 hover:border-background-300 hover:bg-background-50'
      }`}
    >
      <span
        className="absolute inset-y-0 left-0 w-1.5"
        style={{ backgroundColor: cor || CINZA }}
        aria-hidden
      />
      <div className="pl-3">
        <div className="flex items-center gap-2">
          <span
            className="flex h-3 w-3 shrink-0 items-center justify-center rounded-full"
            style={{ backgroundColor: cor || CINZA }}
            aria-hidden
          />
          <span className="min-w-0 flex-1 truncate text-[15px] font-bold leading-tight text-foreground-950">
            {nome}
          </span>
          <span className="shrink-0 rounded-full bg-background-100 px-2 py-0.5 text-[12px] font-semibold text-foreground-800">
            {total}
          </span>
        </div>

        <p className="mt-1 text-[13px] text-foreground-600">
          <span aria-hidden>♂</span> {homens} · <span aria-hidden>♀</span> {mulheres}
          {idadeMedia !== null ? ` · média ${idadeMedia} anos` : ''}
        </p>

        {cidades && (
          <p className="mt-0.5 truncate text-[12px] text-foreground-500">{cidades}</p>
        )}

        {sugestoes > 0 && (
          <p className="mt-1 text-[12px] font-semibold text-accent-700">
            {sugestoes} {sugestoes === 1 ? 'sugestão a confirmar' : 'sugestões a confirmar'}
          </p>
        )}
      </div>
    </button>
  );
}